import Container from "@material-ui/core/Container/index";
import React from "react";

class AppPrivacyPolicy extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        window.scrollTo(0, 0)
    }

    render() {
        const {appStyle} = this.props;

        return (
            <Container className={appStyle.privacyPolicy}>
                <Container className={appStyle.legalTextBottom}>
                    <h1>Privacy Policy</h1> <p>
                </p> <p>
                    The protection of your personal data is of high importance for us. Therefore we process
                    your data exclusively based on the legal regulations (GDPR, TKG 2003). This page is used
                    to inform users of the Capture N' Paste service (which includes both the mobile and the
                    desktop application - hereinafter referred as "service") about the aspects regarding the
                    collection,
                    use
                    and disclosure of personal information.
                </p> <p>
                    If you choose to use this service provided by André Salmhofer, then you agree to the collection
                    and use of information in relation to this policy. The personal information that we
                    collect is used for providing and improving the service. We will not use or share your
                    information with anyone except as described in this privacy policy.
                </p> <p><strong>Information Collection and Use</strong></p>
                    <p>
                        <p>The service only collects and stores data, which are required in order to provide the
                            service.</p>

                        <p>As the main purpose of the service is to take images and videos, the mobile app needs access
                            to
                            your phone's camera. Without this permission the service cannot be provided. The
                            recorded
                            images
                            and videos as well as the related metadata are stored and organized in a
                            secured kind of way with the help of the services provided by <a
                                href={'https://firebase.google.com/'}>Google Firebase</a>.
                            The storage structure and the related authorization rules ensure that the stored
                            elements
                            and
                            related metadata are exclusively accessible by you.</p>

                        <p>To authenticate you and apply the respective authorization rules, a login to the
                            service is required. This is possible with your Google Account using OAuth 2.0.
                            Only after successful authentication you are enabled to use the provided services in its
                            full
                            extent. This way it is ensured, that no one but you can access your data.
                        </p>

                        <p>For establishing the connection between the mobile app and the desktop app, a secured
                            temporary
                            session is created. This session primarily contains the images to be copied from your
                            phone
                            to
                            your workstation's clipboard. In addition it holds your email address and account's
                            profile
                            image as metadata, which is retrieved during the aforementioned OAuth 2.0 authentication
                            process. This metadata is only used within the provided service for visualisation
                            purposes
                            in
                            both mobile and desktop app and is neither permanently stored nor provided to third
                            parties.</p>
                    </p>

                    <p><strong>Retention Time</strong></p>
                    <p>The retention time of the remotely stored images, videos and related metadata is limited to a
                        period
                        of 24 hours. After this period your recordings are permanently deleted and cannot be
                        recovered
                        anymore. The stored session, required to establish the connection between the mobile app and
                        the
                        desktop app, is active for a period of one hour. After one hour of user inactivity, the
                        session
                        and
                        its contained data is automatically deleted.

                        <p><strong>Account Deletion</strong></p>
                        <p>In case no recordings are taken within a 24 hour period, neither images nor videos are
                            existing anymore associated with your account (see section "Retention Time"). The deletion
                            of the Capture N' Paste account as well as all associated data can be manually
                            triggered anytime using the respective functionality inside the app.
                        </p>
                    </p>

                    <p><strong>Usage Analysis</strong></p>
                    <p>For continuously improving the service and the user experience, we are using
                        Google Firebase to collect and analyze anonymous data about the usage of the
                        provided service. This tool is an integral part of the service and therefore it
                        cannot be deactivated. To get more information about the privacy policy of Google
                        products please refer to <a href={'https://firebase.google.com/'}>Google Firebase</a> and <a
                            href={'https://policies.google.com/privacy'}>Google Privacy Policy</a>.</p>

                    <p><strong>Changes to this Privacy Policy</strong></p> <p>
                    We may update our Privacy Policy from time to time. Thus, you are advised to review this page
                    periodically for any changes. We will notify you of any changes by posting the new Privacy
                    Policy on
                    this page.
                </p>
                    <p><strong>Your Rights</strong></p>
                    <p>
                        You have the right to information, correction, deletion, restriction, data portability,
                        revocation and objection with regard to your data stored by us. If you believe that the
                        processing of your data violates the data protection law or your data protection claims have
                        been violated in any other way, you can complain to us via captureNpaste@gmail.com or
                        the data protection authority.
                    </p>
                    <p><strong>Contact</strong></p>
                    <p>If you have any questions or suggestions about the
                        Privacy Policy, do not hesitate to contact us at captureNpaste@gmail.com. If you contact us
                        by
                        email, the data you provide will be stored by us for six months in
                        order to process the request and in the event of follow-up questions. We do not pass on this
                        data
                        without your consent.</p>
                </Container>

                <Container className={appStyle.legalTextStandard}>
                    <h1>Datenschutzerklärung</h1> <p>
                </p> <p>
                    Der Schutz Ihrer persönlichen Daten ist für uns von großer Bedeutung. Deshalb verarbeiten wir
                    Ihre
                    Daten ausschließlich nach den gesetzlichen Bestimmungen (DSGVO, TKG 2003). Diese Seite wird
                    verwendet, um Benutzer des Capture N 'Paste-Services (der sowohl die mobile als auch die
                    Desktop-Anwendung einschließt - im Folgenden als "Service" bezeichnet) über die Aspekte der
                    Erfassung, Verwendung
                    und Offenlegung persönlicher Informationen zu informieren.
                </p> <p>
                    Wenn Sie diesen von André Salmhofer bereitgestellten Service nutzen, stimmen Sie der Erfassung
                    und
                    Verwendung von Informationen im Zusammenhang mit dieser Richtlinie zu. Die von uns gesammelten
                    persönlichen Daten, werden zur Bereitstellung und Verbesserung des Service verwendet. Wir werden
                    Ihre Daten nicht verwenden oder an Dritte weitergeben, außer wie in dieser Datenschutzrichtlinie
                    beschrieben.
                </p> <p><strong>Sammlung und Verwendung von Informationen</strong></p>
                    <p>
                        <p>Das Service sammelt und speichert nur Daten, die zur Bereitstellung des Services
                            erforderlich
                            sind.</p>

                        <p>Da der Hauptzweck des Services darin besteht, Bilder und Videos aufzunehmen, benötigt die
                            mobile App
                            Zugriff auf die Kamera Ihres Telefons. Ohne diese Erlaubnis kann das Service nicht
                            bereitgestellt werden. Die aufgezeichneten Bilder und Videos sowie die zugehörigen
                            Metadaten
                            werden mithilfe der von <a
                                href={'https://firebase.google.com/'}>Google Firebase</a> bereitgestellten Dienste
                            auf
                            sichere Weise gespeichert und organisiert. Die Speicherstruktur und die zugehörigen
                            Berechtigungsregeln stellen sicher, dass die gespeicherten Elemente und zugehörigen
                            Metadaten ausschließlich für Sie zugänglich sind.</p>

                        <p>Um Sie zu authentifizieren und die entsprechenden Autorisierungsregeln anzuwenden, ist
                            eine
                            Anmeldung beim Service erforderlich. Dies ist mit Ihrem Google-Konto unter Verwendung
                            von
                            OAuth 2.0 möglich. Erst nach erfolgreicher Authentifizierung können Sie die
                            bereitgestellten
                            Dienste in vollem Umfang nutzen. Auf diese Weise wird sichergestellt, dass niemand außer
                            Ihnen auf Ihre Daten zugreifen kann.
                        </p>

                        <p>Zum Herstellen der Verbindung zwischen der mobilen App und der Desktop-App, wird eine
                            gesicherte temporäre Session erstellt. Diese Session enthält in erster Linie die Bilder,
                            die
                            von Ihrem Telefon in die Zwischenablage Ihrer Workstation kopiert werden sollen. Darüber
                            hinaus enthält es Ihre E-Mail-Adresse und das Profilbild Ihres Kontos als Metadaten,
                            welche
                            während des oben genannten OAuth 2.0-Authentifizierungsprozesses abgerufen werden. Diese
                            Metadaten werden innerhalb des bereitgestellten Services nur zu Visualisierungszwecken
                            sowohl in der mobilen als auch in der Desktop-App verwendet und werden weder dauerhaft
                            gespeichert
                            noch an Dritte weitergegeben.</p>
                    </p>

                    <p><strong>Aufbewahrungszeit</strong></p>
                    <p>Die Aufbewahrungszeit der remote gespeicherten Bilder, Videos und dazugehörigen Metadaten ist
                        auf
                        einen Zeitraum von 24 Stunden begrenzt. Nach diesem Zeitraum werden Ihre Aufnahmen dauerhaft
                        gelöscht und können nicht mehr wiederhergestellt werden. Die Session, die zum
                        Herstellen der Verbindung zwischen der mobilen App und der Desktop-App erforderlich ist, ist
                        für einen Zeitraum von einer Stunde aktiv. Nach einer Stunde Inaktivität des Benutzers,
                        werden die Session und die darin enthaltenen Daten automatisch gelöscht.

                        <p><strong>Löschung des Kontos</strong></p>
                        <p>Falls innerhalb von 24 Stunden keine Aufzeichnungen gemacht werden, sind weder Bilder noch
                            Videos mehr in Ihrem Konto vorhanden (siehe Abschnitt "Aufbewahrungszeit"). Das Löschen
                            des Capture N' Paste Accounts, sowie aller kontobezogenen Daten, kann jederzeit manuell
                            über die entsprechende Funktionalität in der App ausgelöst werden.
                        </p>
                    </p>

                    <p><strong>Nutzungsanalyse</strong></p>
                    <p>Um den Service und die User-Experience kontinuierlich zu verbessern, verwenden wir Google
                        Firebase, um anonyme Daten über die Nutzung des bereitgestellten Services zu sammeln und zu
                        analysieren. Dieses Tool ist ein wesentlicher Bestandteil des Dienstes und kann daher nicht
                        deaktiviert werden. Weitere Informationen zu den Datenschutzbestimmungen von
                        Google-Produkten
                        finden Sie unter <a href={'https://firebase.google.com/'}>Google Firebase</a> und <a
                            href={'https://policies.google.com/privacy'}>Google Datenschutzerklärung &
                            Nutzungsbedingungen</a>.</p>

                    <p><strong>Änderungen dieser Datenschutzerklärung</strong></p> <p>
                    Wir behalten uns das Recht vor, unsere Datenschutzrichtlinie von Zeit zu Zeit zu aktualisieren. Es
                    wird daher empfohlen,
                    diese Seite regelmäßig auf Änderungen zu überprüfen. Wir werden Sie über Änderungen informieren,
                    indem wir die neue Datenschutzrichtlinie auf dieser Seite veröffentlichen.
                </p>
                    <p><strong>Ihre Rechte</strong></p>
                    <p>
                        Ihnen stehen bezüglich Ihrer bei uns gespeicherten Daten grundsätzlich die Rechte auf
                        Auskunft,
                        Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu.
                        Wenn
                        Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre
                        datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich
                        bei
                        uns (captureNpaste@gmail.com) oder der Datenschutzbehörde beschweren.
                    </p>
                    <p><strong>Kontakt</strong></p>
                    <p>Wenn Sie Fragen oder Anregungen zur Datenschutzrichtlinie haben, kontaktieren Sie uns unter
                        captureNpaste@gmail.com. Wenn Sie uns per E-Mail kontaktieren, werden die von
                        Ihnen angegebenen Daten von uns sechs Monate lang gespeichert, um die Anfrage zu bearbeiten.
                        Wir
                        geben diese Daten nicht ohne Ihre Zustimmung weiter.</p>
                </Container>
            </Container>
        );
    }
}

export default AppPrivacyPolicy;